import React from "react";
import { useTranslation } from "react-i18next";
import { Truck } from "lucide-react";

// Green "Free US shipping" badge. Single source used on the product page,
// the Shop hero, and the cart so the styling stays identical everywhere.
export const FreeShippingBadge = ({ testid = "free-shipping-badge", className = "" }) => {
  const { t } = useTranslation();
  return (
    <p className={`text-xs flex items-center gap-1.5 ${className}`} data-testid={testid} style={{ color: "var(--success)" }}>
      <Truck size={13} /> {t("shipping.freeUs")}
    </p>
  );
};

export default FreeShippingBadge;
